import React, { Fragment, ReactElement } from 'react';

import { IQATestableProps } from '../../shared/types/IQATestableProps';

import { ISelectOption, OzSelectInputOption } from './SelectOption';

export type ISelectOptionsProps = IQATestableProps & {
    options: ISelectOption[];
};

export function OzSelectInputOptions (props: ISelectOptionsProps): ReactElement {
    const {
        options,
        'data-testid': dataTest = '',
    }: ISelectOptionsProps = props;

    return (
        <Fragment>
            {options.map((option: ISelectOption, index: number): ReactElement => {
                return (
                    <OzSelectInputOption key={index} option={option} index={index} data-testid={dataTest} />
                );
            })}
        </Fragment>
    );
}

export function getDefaultSelectedOption (
    options: ISelectOption[],
    defaultSelectedValue: any | undefined,
    defaultSelectedIndex: number | undefined,
): ISelectOption {
    let initialOption: ISelectOption;

    if (defaultSelectedValue) {
        initialOption = options.find((opt: ISelectOption): boolean => {
            return opt.value === defaultSelectedValue;
        }) || options[0];
    } else {
        if (
            defaultSelectedIndex === undefined ||
            defaultSelectedIndex < 0 ||
            defaultSelectedIndex > options.length
        ) {
            initialOption = options[0];
        } else {
            // increase the defaultIndex value by 1 because of the addition of emptyOption to options
            initialOption = options[defaultSelectedIndex + 1];
        }
    }

    return initialOption;
}
